import { createRoot } from 'react-dom/client';
import { JobListingProvider } from '@scripts/frontend/job-listing/JobListingContext';
import { JobListingMain } from './components';

const rootElements = document.querySelectorAll('[data-aq-jobs-render="listing-main"]');

rootElements.forEach((element) => {
  const root = createRoot(element);
  const headerData = element.getAttribute('data-header-data') || {};
  const homeUrl = element.getAttribute('home-url') || '/';
  const listingBaseUrl = element.getAttribute('data-job-base-url') || '/find-work';

  root.render(
    <JobListingProvider value={{
      headerData: headerData ? JSON.parse(headerData) : {},
      homeUrl,
      listingBaseUrl,
    }}>
      <JobListingMain />
    </JobListingProvider>,
  );
});
